export default __webpack_public_path__ + "static/media/marketing.e747b6f1.svg";